define('glu/itemView',['require','marionette','./core/internal/viewMixins'],function(require) {
    'use strict';

    var Marionette = require('marionette'),
        viewMixins = require('./core/internal/viewMixins');

    return Marionette.ItemView.extend(viewMixins(Marionette.ItemView));
});

